var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Samples"},[_c('Header'),_c('div',{staticClass:"PageContentWrap"},[_c('Accordion',{attrs:{"title":_vm.mixWB('TABLE_FOR_THE_REPORT'),"bodyComponent":_vm.Table,"bodyComponentProps":{
        samples: _vm.sortedScreeningSamples,
      }}}),_c('Accordion',{attrs:{"title":_vm.mixWB('LIST_OF_SAMPLES'),"bodyComponent":_vm.SamplesList}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }